import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Row,
  Modal,
  Tooltip,
  Badge,
  Skeleton,
  Popover,
  Button,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  DownloadOutlined,
  DownOutlined,
  ShareAltOutlined,
  PrinterFilled,
} from "@ant-design/icons";
import "./index.css";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";
import moment from "moment";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import {
  deletePurchaseList,
  loadPurchaseOrders,
} from "../../store/purchase-orders/actions";
import { ledgerStatementList } from "../Items/data";
import html2canvas from "html2canvas";
import { ToWords } from "to-words";
import jsPDF from "jspdf";

const PurchaseSelection = (props) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoDetails = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const userInfoName = !isEmpty(userNameDetails)
    ? userNameDetails.user.name
    : "";
  const userInfoMobile = !isEmpty(userNameDetails)
    ? userNameDetails.user.mobileNo
    : "";
  const purchaseListId = { organizationId: userInfoDetails };

  //partys tabs

  //Props values from parties home

  const itemList =
    props.location && props.location.state ? props.location.state.itemLi : "";

  const organizationId = props.location.state
    ? props.location.state.organizationId
    : "";
  const userId = props.location.state ? props.location.state.userId : "";

  // const partyTabId =
  //   props.location && props.location.state ? props.location.state.data._id : "";

  const purchaseData =
    props.location && props.location.state ? props.location.state : "";

  console.log(purchaseData, "purchaseData");

  //api loader
  useEffect(() => {
    dispatch(loadPurchaseOrders(purchaseListId));
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { parties_list = [] } = useSelector((state) => state.PurchaseOrders);

  const [pageRouting, setPageRouting] = useState(false);
  const history = useHistory();

  //category api integrations
  const [deletePurchaseModal, setDeletePurchaseModal] = useState(false);

  //deletPurchase api integrations
  const deletePurchaseOrders = () => {
    const itemListData = {
      organizationId: organizationId,
      poId: purchaseData._id,
      deletedBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
    };
    dispatch(deletePurchaseList(itemListData));
    setTimeout(() => {
      dispatch(loadPurchaseOrders(purchaseListId));
      setDeletePurchaseModal(false);
      setTimeout(() => {
        history.push("/purchase-orders");
      }, 1000);
      toast.error("Purchase orders deleted successfully");
    }, 1000);
  };

  //Ledger statement section

  // const [mouseEnter, setMouseEnter] = useState(false);
  const [ledgerData, setLedgerData] = useState({
    startMonth: "",
    endMonth: "",
    startOfMonth: "",
    endOfMonth: "",
  });
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");

  console.log(ledgerData, "ledgerData");
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    setLedgerData({
      startMonth: "",
      endMonth: "",
      startOfMonth: startOfMonth,
      endOfMonth: endOfMonth,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toWords = new ToWords();

  //state data's

  const purchaseOrdersTable =
    parties_list && parties_list.length > 0
      ? parties_list.map((data, index) => {
          return {
            _id: data._id,
            key: index + 1,
            NetAmount: data.NetAmount,
            authorizedsignature: data.authorizedsignature,
            autoamountroundoff: data.autoamountroundoff,
            beforeautoroundoffamount: data.beforeautoroundoffamount,
            charge: data.charge,
            createdAt: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "",
            createdBy: data.createdBy,
            financialyearId: data.financialyearId,
            isHistory: data.isHistory,
            items: data.items,
            notes: data.notes,
            organizationId: data.organizationId,
            poDate: data.poDate ? moment(data.poDate).format("DD-MM-YYYY") : "",
            poNo: data.poNo,
            povalidDate: data.povalidDate
              ? moment(data.povalidDate).format("DD-MM-YYYY")
              : "",
            subtotalamount: data.subtotalamount,
            taxableAmonut: data.taxableAmonut,
            termsandconditions: data.termsandconditions,
            totaltax: data.totaltax,
            totaltaxableValue: data.totaltaxableValue,
            transActionType: data.transActionType,
            type: data.type,
            updatedAt: data.updatedAt,
            vendorAddress: data.vendorAddress,
            vendorCity: data.vendorCity,
            vendorId: data.vendorId,

            vendorName: data.vendorName,
            vendorNameValue: data.vendorName,

            status: (
              <Badge
                className={
                  data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName === "Active"
                    ? "bg-[#edf6ef] font-semibold rounded-md text-[#49a563] p-2"
                    : "bg-[#f1e7e9] font-semibold rounded-md text-[#d01717] p-2"
                }
              >
                {data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName}
              </Badge>
            ),
          };
        })
      : [];

  console.log(purchaseOrdersTable, "purchaseOrdersTable");

  // const totalCredit =
  //   purchaseOrdersTable.length > 0
  //     ? purchaseOrdersTable.reduce((a, b) => a.credit + b.credit)
  //     : 0;
  // const totalDebit =
  //   purchaseOrdersTable.length > 0
  //     ? purchaseOrdersTable.reduce((a, b) => a.debit + b.debit)
  //     : 0;

  // const totalTdsDeduct =
  //   purchaseOrdersTable.length > 0
  //     ? purchaseOrdersTable.reduce(
  //         (a, b) => a.tdsDeductParty + b.tdsDeductParty
  //       )
  //     : 0;
  // const totalTdsDeductSelf =
  //   purchaseOrdersTable.length > 0
  //     ? purchaseOrdersTable.reduce((a, b) => a.tdsDeductSelf + b.tdsDeductSelf)
  //     : 0;
  // const totalBalance =
  //   purchaseOrdersTable.length > 0
  //     ? purchaseOrdersTable.reduce((a, b) => a.balance + b.balance)
  //     : 0;
  const [downloadLoading, setDownloadLoading] = useState(false);

  //download pdf
  const handleDownloadPDF = () => {
    const input = document.getElementById("pdf-content");
    // Specify the id of the element you want to convert to PDF
    setDownloadLoading(true);
    setTimeout(() => {
      html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        pdf.addImage(imgData, "PNG", 10, 5);
        pdf.save("purchase-orders.pdf");
        setDownloadLoading(false);
        // Specify the name of the downloaded PDF file
      });
    }, 1200);
  };

  //print pdf
  const handlePrintPDF = () => {
    const input = document.getElementById("pdf-content");
    // Specify the id of the element you want to convert to PDF
    var headstr = "<html><head><title>Booking Details</title></head><body>";
    var footstr = "</body>";
    var newstr = input.innerHTML;
    var oldstr = document.body.innerHTML;
    document.body.innerHTML = headstr + newstr + footstr;
    window.print();
    window.close();
    document.body.innerHTML = oldstr;
    return false;
    // window.print(input)
  };

  //Calculate totals
  const calculateTotals = (rows) => {
    let quantityCount = 0;

    rows.forEach((row) => {
      quantityCount += parseFloat(row.qty) || 0;
    });

    return { quantityCount };
  };

  const [totals, setTotals] = React.useState({
    quantityCount: 0,
  });

  useEffect(() => {
    if (purchaseData && purchaseData.items.length > 0) {
      const total = calculateTotals(purchaseData.items);
      setTotals(total);
    }
  }, [purchaseData]);
  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Purchase | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm">
        <Col span={24}>
          <Row>
            <Col span={24}>
              <Row>
                <Col span={24} className="bg-[#ffffff]">
                  <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
                    <div className="flex">
                      <ArrowLeftOutlined
                        onClick={() => setPageRouting(true)}
                        className="font-bold text-[18px]"
                      />
                      <h1 className="text-[20px] ml-2 mt-2 font-semibold">
                        {"Purchase Orders #"}
                        {purchaseData ? purchaseData.poNo : 1}
                      </h1>
                    </div>

                    <div className="flex">
                      <Tooltip
                        title="Edit Purhcase Details"
                        placement="left"
                        rootClassName="text-[10px]"
                      >
                        <div
                          onClick={() => {
                            history.push({
                              pathname: "/create-purchase-orders",
                              state: {
                                purchaseData: purchaseData ? purchaseData : "",
                                organizationId: organizationId,
                                userId: userId,
                                itemList: itemList,
                              },
                            });
                          }}
                          className="border flex rounded-md justify-between  pl-3 pr-2 pt-2 pb-2 ml-3  cursor-pointer"
                        >
                          <EditOutlined className="text-[16px] pr-3" />
                        </div>
                      </Tooltip>
                      <Tooltip
                        title="Delete This Purchase"
                        placement="bottom"
                        rootClassName="text-[10px]"
                      >
                        <div
                          onClick={() => setDeletePurchaseModal(true)}
                          className="border border-1 border-red-200 text-[red] rounded-md ml-3 p-2.5 cursor-pointer"
                        >
                          <DeleteOutlined />
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </Col>
                <Col span={24} className="pl-4 pt-4 pb-4 pr-1 bg-[#ffffff]">
                  <Row>
                    <Col span={18}>
                      <Row>
                        <Col span={6} className="pr-3">
                          {loading ? (
                            <Skeleton.Input className="w-[100%]"></Skeleton.Input>
                          ) : (
                            <div
                              onClick={handleDownloadPDF}
                              className="cursor-pointer flex border p-2 rounded-md border-1 text-center"
                            >
                              <DownloadOutlined className="text-[16px] mr-3" />{" "}
                              Download
                            </div>
                          )}
                        </Col>
                        <Col span={6} className="pr-3">
                          {loading ? (
                            <Skeleton.Input className="w-[100%]"></Skeleton.Input>
                          ) : (
                            <div
                              onClick={handlePrintPDF}
                              className="flex border p-2 rounded-md  border-1 text-center"
                            >
                              <PrinterFilled className="cursor-pointer text-[16px] mr-3" />{" "}
                              Print PDF
                            </div>
                          )}
                        </Col>
                        <Col span={6}>
                          {loading ? (
                            <Skeleton.Input className="w-[100%]"></Skeleton.Input>
                          ) : (
                            <div className="text-start">
                              <Popover
                                placement="bottomRight"
                                trigger={"click"}
                                content={ledgerStatementList}
                              >
                                <Tooltip
                                  title="Easily perform bulk actions on all your Parties"
                                  placement="left"
                                  rootClassName="text-[10px]"
                                >
                                  <div className="border rounded-sm flex justify-between w-[150px] pl-3 pr-2 pt-2 pb-2 cursor-pointer">
                                    <div>
                                      <ShareAltOutlined className="mr-2" />
                                      Share
                                    </div>
                                    <DownOutlined />
                                  </div>
                                </Tooltip>
                              </Popover>
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Col>
                    <Col span={6}>
                      <Row className="flex">
                        <Col span={20} className="ml-5">
                          <div>
                            {loading ? (
                              <Skeleton.Input
                                style={{
                                  paddingRight: "25px",
                                  marginRight: "25px",
                                  width: "100%",
                                  height: "40px",
                                }}
                              ></Skeleton.Input>
                            ) : (
                              <Button
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                className={
                                  "create-purchase-selection-orders-button"
                                }
                              >
                                <Link
                                  to={{
                                    pathname: "#",
                                    // pathname: "/create-purchase-orders",
                                    state:
                                      parties_list && parties_list.length > 0
                                        ? parties_list.length
                                        : 1,
                                  }}
                                >
                                  Convert Purchase Invoice
                                </Link>
                              </Button>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <Row className="border border-b-1 border-t-0 border-x-0 flex mt-3 mb-3">
                    <Col span={24} className="mb-4 pb-6">
                      <div
                        // onMouseEnter={() => setMouseEnter(true)}
                        // onMouseLeave={() => setMouseEnter(false)}
                        className={
                          // mouseEnter
                          //   ?
                          "border border-1 rounded-md pb-3 mb-3 bg-[#e5e5e5] add-purchase-ledger-statment-main"
                          // : "border border-1 rounded-md pt-3 pb-3 bg-[#e5e5e5]"
                        }
                      >
                        <Row className="flex justify-center">
                          <Col
                            md={18}
                            className={
                              downloadLoading
                                ? "pl-8 pr-16 pt-4 pb-4 border-solid rounded-sm bg-[#ffffff]"
                                : "pl-8 pr-8 pt-4 pb-4 border-solid rounded-sm bg-[#ffffff]"
                            }
                          >
                            <Row id="pdf-content">
                              <Col span={24} className="pb-3 pt-3">
                                <h1 className="text-[14px] font-semibold uppercase mt-2 mb-7 party-label">
                                  Purchase Order
                                </h1>
                                <div className="">
                                  <h1 className="font-semibold party-label text-[24px]">
                                    {userInfoName}
                                  </h1>
                                  <p className="party-label flex">
                                    <p className="text-[12px] font-semibold mr-2">
                                      Mobile:
                                    </p>
                                    <p>{userInfoMobile}</p>
                                  </p>
                                </div>
                              </Col>
                              <Col span={24} className="pt-3 mb-3">
                                <Row className="w-[100%] bg-[#000000] pl-5 pr-5 pt-1 pb-1"></Row>
                                <Row className="w-[100%] flex justify-between bg-[#e1e1e1] pl-5 pr-5 pt-5 pb-5">
                                  <div className="flex">
                                    <h1 className="purchase-label text-[14px] font-semibold mr-3">
                                      PO No:
                                    </h1>
                                    <p className="mt-[-2px]">
                                      {purchaseData ? purchaseData.poNo : 1}
                                    </p>
                                  </div>
                                  <div className="flex">
                                    <h1 className="purchase-label text-[14px] font-semibold mr-3">
                                      PO Date:
                                    </h1>
                                    <p className="mt-[-2px]">
                                      {purchaseData
                                        ? moment(purchaseData.poDate).format(
                                            "DD/MM/YYYY"
                                          )
                                        : ""}
                                    </p>
                                  </div>
                                  <div className="flex">
                                    <h1 className="purchase-label text-[14px] font-semibold mr-3">
                                      Expiry Date:
                                    </h1>
                                    <p className="mt-[-2px]">
                                      {purchaseData
                                        ? moment(
                                            purchaseData.povalidDate
                                          ).format("DD/MM/YYYY")
                                        : ""}
                                    </p>
                                  </div>
                                </Row>
                              </Col>
                              <Col span={24} className="pt-2 mb-3">
                                <Row className="w-[100%] flex pb-5">
                                  <Col md={10}>
                                    <div className="">
                                      <h1 className="purchase-label text-[14px] font-semibold mr-3 uppercase">
                                        Bill From
                                      </h1>
                                      <p className="mt-1  text-[14px]  purchase-label font-semibold">
                                        {purchaseData
                                          ? purchaseData.vendorName
                                          : ""}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col md={10}>
                                    <div className="">
                                      <h1 className="purchase-label  text-[14px] font-semibold mr-3 uppercase">
                                        Ship From
                                      </h1>
                                      <p className="mt-1 text-[14px] purchase-label font-semibold">
                                        {purchaseData
                                          ? purchaseData.vendorName
                                          : ""}
                                      </p>
                                      <p className="mt-1">
                                        {purchaseData
                                          ? purchaseData.vendorAddress +
                                            ", " +
                                            purchaseData.vendorCity
                                          : // ? purchaseData.vendorAddress + ", " + purchaseData.vendorCity + ", " + purchaseData.vendorStateName
                                            ""}
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>

                              {/* PO statement */}
                              <Col
                                span={24}
                                className="mt-3 add-create-item-table"
                              >
                                <table className="mb-6 table-purchase-serial table-responsive">
                                  <thead>
                                    <tr className="table-head-main">
                                      <th className="uppercase table-purchase-head text-[12px] font-semibold">
                                        Items
                                      </th>
                                      <th className="uppercase table-purchase-head text-[12px] font-semibold">
                                        Qty
                                      </th>
                                      <th className="uppercase table-purchase-head text-[12px] font-semibold">
                                        Rate
                                      </th>
                                      <th className="uppercase table-purchase-head text-[12px] font-semibold">
                                        Tax
                                      </th>
                                      <th className="uppercase text-end table-purchase-head text-[12px] font-semibold">
                                        Amount
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {purchaseData &&
                                    purchaseData.items &&
                                    purchaseData.items.length > 0
                                      ? purchaseData.items.map(
                                          (data, index) => {
                                            return (
                                              <tr
                                                key={index}
                                                className={
                                                  "uppercase table-purchase-row border border-b-1 border-x-0 border-t-0"
                                                }
                                              >
                                                <td className="p-3">
                                                  {data.itemName}
                                                </td>
                                                <td className="p-3">
                                                  {data.qty
                                                    ? data.qty + " PCS"
                                                    : 0 + " PCS"}
                                                </td>

                                                <td className="p-3">
                                                  {data.priceofitem}
                                                </td>
                                                <td className="p-3">
                                                  <h1 className="mt-2">
                                                    {data.qty
                                                      ? parseInt(
                                                          data.qty *
                                                            data.taxValue
                                                        )
                                                      : data.taxValue}
                                                  </h1>
                                                  <p className="text-[8px]">
                                                    (18%)
                                                    {/* ({data.taxValue}) */}
                                                  </p>
                                                </td>
                                                <td className="p-3 text-end">
                                                  {data.totalamount}
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )
                                      : ""}
                                  </tbody>
                                </table>
                                <table className="mt-12 mb-4 w-[100%]">
                                  <tbody className="w-[100%]">
                                    <tr
                                      style={{
                                        borderTop: "2px solid gray",
                                        borderBottom: "2px solid gray",
                                      }}
                                      className="font-semibold"
                                    >
                                      <td
                                        className="w-[28%] uppercase p-3 font-semibold text-[14px]"
                                        // colSpan={2}
                                      >
                                        {"SubTotal"}
                                      </td>

                                      <td className="w-[16%] p-3 text-start">
                                        <p className="">
                                          {totals.quantityCount}
                                        </p>
                                      </td>
                                      <td className="w-[16%] p-3">{""}</td>
                                      <td className="w-[16%] p-3 text-start">
                                        <p className="">
                                          {purchaseData && purchaseData.totaltax
                                            ? "₹ " + purchaseData.totaltax
                                            : "₹ " + 0}
                                        </p>
                                      </td>
                                      <td className="w-[24%] p-3 text-end">
                                        <p className="">
                                          {purchaseData &&
                                          purchaseData.subtotalamount
                                            ? "₹ " + purchaseData.subtotalamount
                                            : "₹ " + 0}
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <Row>
                                  <Col md={24} className="pl-2 pr-2">
                                    <Row>
                                      <Col md={16}>
                                        <div className="purchase-label">
                                          <h1 className="font-semibold uppercase text-[14px]">
                                            Terms and Conditions
                                          </h1>
                                          <p className="text-[12px]">
                                            {purchaseData
                                              ? purchaseData.termsandconditions
                                              : ""}
                                          </p>
                                        </div>
                                      </Col>
                                      <Col md={8}>
                                        <Row>
                                          <Col md={16}>
                                            <div className="purchase-label">
                                              <h1 className="uppercase mb-2 text-[12px]">
                                                Taxable Amount
                                              </h1>
                                              <h1 className="uppercase mb-2 text-[12px]">
                                                CGST @9%
                                              </h1>
                                              <h1 className="uppercase mb-2 text-[12px]">
                                                SGST @9%
                                              </h1>
                                              {purchaseData &&
                                              purchaseData.autoamountroundoff ? (
                                                <h1 className="uppercase mb-2 text-[12px]">
                                                  RoundOff Value
                                                </h1>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          </Col>
                                          <Col md={8}>
                                            <div className="">
                                              <p className="mb-1 flex justify-end">
                                                <div className="flex">
                                                  ₹{" "}
                                                  <h1 className="purchase-label mt-[0.5px] ml-1">
                                                    {purchaseData
                                                      ? purchaseData.totaltaxableValue
                                                      : 0}
                                                  </h1>
                                                </div>
                                              </p>
                                              <p className="mb-1 flex justify-end">
                                                <div className="flex">
                                                  ₹{" "}
                                                  <h1 className="purchase-label mt-[0.5px] ml-1">
                                                    {purchaseData
                                                      ? purchaseData.totaltax /
                                                        2
                                                      : 0}
                                                  </h1>
                                                </div>
                                              </p>
                                              <p className="mb-1 flex justify-end">
                                                <div className="flex">
                                                  ₹{" "}
                                                  <h1 className="purchase-label mt-[0.5px] ml-1">
                                                    {purchaseData
                                                      ? purchaseData.totaltax /
                                                        2
                                                      : 0}
                                                  </h1>
                                                </div>
                                              </p>
                                              {purchaseData &&
                                              purchaseData.autoamountroundoff ? (
                                                <p className="mb-1 mt-[5px] flex justify-end">
                                                  <div className="flex">
                                                    ₹{" "}
                                                    <h1 className="purchase-label mt-[0.5px] ml-1">
                                                      {purchaseData.autoamountroundoff
                                                        ? purchaseData.autoamountroundoff
                                                        : 0}
                                                    </h1>
                                                  </div>
                                                </p>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row
                                          className="mt-2 pt-2 pb-2"
                                          style={{
                                            borderTop: "1px solid gray",
                                            borderBottom: "1px solid gray",
                                          }}
                                        >
                                          <Col md={16}>
                                            <div className="purchase-label">
                                              <h1 className="uppercase font-semibold text-[12px]">
                                                Total Amount
                                              </h1>
                                            </div>
                                          </Col>
                                          <Col md={8}>
                                            <div className="">
                                              <p className="flex justify-end">
                                                <div className="flex ml-3">
                                                  ₹{" "}
                                                  <h1 className="font-semibold purchase-label mt-[0.5px] ml-1">
                                                    {purchaseData
                                                      ? purchaseData.NetAmount
                                                      : 0}
                                                  </h1>
                                                </div>
                                              </p>
                                            </div>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                                <Row className="mt-4 mb-4 pt-2 pb-2">
                                  <Col md={24} className="flex justify-end">
                                    <div className="purchase-label">
                                      <h1 className="font-semibold text-end text-[12px]">
                                        Total Amount (in words)
                                      </h1>
                                      <h1 className="mt-1 font-medium text-[12px] text-end">
                                        {purchaseData && purchaseData.NetAmount
                                          ? toWords.convert(
                                              purchaseData.NetAmount,
                                              {
                                                currency: true,
                                                ignoreDecimal: true,
                                              }
                                            )
                                          : ""}
                                      </h1>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            {/* Parties input section with bulk actions */}
          </Row>
        </Col>
      </Row>

      <Modal
        open={pageRouting}
        onOk={() => {
          setPageRouting(false);
          history.push("/purchase-orders");
        }}
        closeIcon
        maskClosable={false}
        rootClassName="p-15 h-[300px]"
        okText={"Yes, Leave"}
        cancelText={"No, Stay"}
        onCancel={() => setPageRouting(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <div className="mr-3">
              <OkBtn />
            </div>
            <CancelBtn />
          </div>
        )}
        width={500}
      >
        <div className="text-center w-[100%]">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to leave this page?
          </h1>
          <p className="text-center text-[14px] mt-2">
            All unsaved changes will be lost!
          </p>
        </div>
      </Modal>

      {/* Delete purchase modal */}

      <Modal
        open={deletePurchaseModal}
        onOk={() => {
          deletePurchaseOrders();
        }}
        closeIcon
        maskClosable={false}
        okText={`Delete Purchase Order`}
        cancelText={"Cancel"}
        okType="danger"
        onCancel={() => setDeletePurchaseModal(false)}
        height={300}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <CancelBtn />
            <div className="ml-3">
              <OkBtn />
            </div>
          </div>
        )}
      >
        <div className="text-center w-[100%] p-7">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to delete these purchase?
          </h1>
          <p className="text-center text-[14px] mt-2">
            The selected purchase will be deleted from the purchase Inventory.
            Once deleted you will not be able to restore these purchase.
          </p>
        </div>
      </Modal>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="colored"
      />
    </React.Fragment>
  );
};

PurchaseSelection.propTypes = {
  location: PropTypes.any,
};

export default PurchaseSelection;
